<template>
  <nx-date-time-picker
    v-validate
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    data-vv-value-path="value"
    :value="value"
    :name="name"
    :label="label"
    :minDate="minDate"
    :maxDate="maxDate"
    :required="required"
    :timeLabel="timeLabel"
    :disabled="disabled"
    :autoclose="true"
    @input="onInput($event)"
    @focus="onFocus($event)"
    @blur="onBlur($event)"
  />
</template>

<script>
import FormDatePicker from './FormDatePicker';

export default {
  name: 'nx-form-date-time-picker',
  extends: FormDatePicker,
  components: {
    NxDateTimePicker: () => import('@/components/date/DateTimePicker.vue'),
  },
  props: {
    timeLabel: String,
  },
};
</script>
